import { useContext } from 'react';

import { ThemeContext } from 'contexts/Theme/ThemeContext';

export const useThemeContext = () => useContext(ThemeContext);
